import styled from 'styled-components';
import DefaultTable from '../../CommonComponents/Table';
import DefaultTableBody from '../../CommonComponents/Table/components/Body';
import DefaultTableHeader from '../../CommonComponents/Table/components/Header';
import DefaultTableRow from '../../CommonComponents/Table/components/Row';
import DefaultTableCell, {
  RightAlignedCell as DefaultRightAlignedCell,
  CenterAlignedCell as DefaultCenterAlignedCell,
} from '../../CommonComponents/Table/components/Cell';

export const Table = styled(DefaultTable)`
  border: none;
  border-collapse: separate;
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  background: transparent;
`;

export const TableBody = styled(DefaultTableBody)``;

export const HeaderTableCell = styled.th`
  background: #e5e7eb;
  color: #444;
  text-transform: uppercase;
  padding: 16px 10px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #d9d7d7;
  border-top: 1px solid #d9d7d7;

  &:first-child {
    border-left: 1px solid #d9d7d7;
  }

  &:last-child {
    border-right: 1px solid #d9d7d7;
  }
`;

export const CenterAlignedCell = styled(DefaultCenterAlignedCell)``;

const cellStyle = `  
  border-bottom: 1px solid #d9d7d7 !important;
  padding: 16px 10px !important;
  border-radius: 0 !important;
  
  p {
    margin: 0;
    padding: 0;
  }

  &:first-child {
    border-left: 1px solid #d9d7d7 !important;
  }
  &:last-child {
    border-right: 1px solid #d9d7d7 !important;
  }
`;

export const RightAlignedCell = styled(DefaultRightAlignedCell)`
  ${cellStyle}
`;

export const TableCell = styled(DefaultTableCell)`
  ${cellStyle}
`;

export const TableHeader = styled(DefaultTableHeader)<{ isFirst?: boolean }>`
  ${props => {
    if (props.isFirst) {
      return `
        border-left: 1px solid #d9d7d7;
        border-right: 1px solid #d9d7d7;
      `;
    }
    return `
      ${TableCell},
      ${RightAlignedCell} {
        border-radius: 0 !important;
        white-space: nowrap;
      }
    `;
  }}
`;

const footerCellStyle = `
  border-bottom: none;
  &:first-child {
    border-left: none;
  }
  &:last-child {
    border-right: 1px solid #d9d7d7 !important;
  }
`;

export const FooterTableCell = styled(DefaultTableCell)`
  ${footerCellStyle}
`;
export const FooterTableRightAlignedCell = styled(DefaultRightAlignedCell)`
  ${footerCellStyle}
`;

export const TableRow = styled(DefaultTableRow)``;
